(function ($) {
  "use strict";
  $(document).ready(function () {
    const slideTxt = $("#blogs-slider-text");
    const slider = $(".blogsSlider");
    if (slider.length > 0) {
      const swiper = new Swiper(".blogsSlider", {
        breakpoints: {
          0: {
            slidesPerView: 1.2,
            spaceBetween: 10,
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          1024: {
            slidesPerView: 2,
            spaceBetween: 30,
          },
          1200: {
            slidesPerView: 2,
            spaceBetween: 30,
          },
        },
        slidesPerView: 2,
        spaceBetween: 30,
        navigation: {
          nextEl: ".blogs-slider-next",
          prevEl: ".blogs-slider-prev",
        },
      });
    }
  });
})(jQuery, this);
